import productService from "../../../../services/ProductService"
import Notify from "../../../../elements/Notify"
import Dialog from "../../../../elements/Dialog"

export default {
   name: 'ProductList',
   data() {
      return {
         filter: '',
         loading: false,
         columns: [
            {
               name: 'number',
               label: '#',
               align: 'left',
               style: 'width: 50px'
            },
            {
               name: 'product',
               label: 'Producto',
               align: 'left',
               field: 'name',
            },
            {
               name: 'offer',
               label: 'En oferta',
               align: 'center',
               field: 'offer_status',
               style: 'width: 80px'
            },
            {
               name: 'price',
               label: 'Precio (S/)',
               align: 'center',
               field: 'price',
               style: 'width: 80px'
            },
            {
               name: 'status',
               label: 'Disponible',
               align: 'center',
               field: 'status',
               style: 'width: 80px'
            },
            {
               name: 'action',
               label: 'Acciones',
               align: 'center',
               style: 'width: 200px'
            },
         ],
         tableData: []
      }
   },
   created() {
      this.$store.dispatch('title', 'Productos')
      this.loading = true;
      productService.getRef().on('value', snapshot => {
         this.setTableData(snapshot.val())
         this.loading = false
      })
   },
   mounted() {
   },
   methods: {
      deleteProduct(product) {
         Dialog.confirm('Eliminar', '¿Esta seguro de querer eliminar este producto? No se podrá recuperar esta información nuca mas.')
            .then(() => {
               productService.deleteProduct(product.id, product.category_id)
                  .then(() => {
                     Notify.success("Se eliminó correctamente.")
                  })
                  .catch((e) => {
                     Notify.error(e)
                  })
            })
            .catch(() => {
               Notify.info("Gracias por no eliminarme.")
            })
      },
      changeStatus(product) {
         productService.updateStatus(product)
            .then(() => {
               Notify.success("Se actualizó el estado del producto.")
            })
            .catch((e) => {
               Notify.error(e)
            })
      },
      setTableData(data) {
         this.tableData = []
         for (const key in data) {
            if (data.hasOwnProperty(key)) {
               const element = data[key]
               element.status = element.status == '1'
               this.tableData.push(element)
            }
         }
      }
   }
}
